import { render, staticRenderFns } from "./ExpiredCardTile.vue?vue&type=template&id=4045a03a&"
import script from "./ExpiredCardTile.vue?vue&type=script&lang=js&"
export * from "./ExpiredCardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports